import { useQuery, UseQueryResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { officeFactsItem as getOfficeFacts } from '../utils/urls';

import { OfficeFactsInput } from 'types/accounts';
import { ErrorModal } from 'types/modalTypes';

async function fetchOfficeFacts({ id }: TVariables): Promise<APIResult> {
  if (!id)
    return new Promise((resolve, reject) => {
      reject();
    });
  const response = await fetch(getOfficeFacts(id), {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type APIResult = {
  IsSuccess: boolean;
  StatusCode: number;
  Data: OfficeFactsInput | null;
};

type TResult = {
  officeFactsReturn: OfficeFactsInput;
  officeFactsInputs: OfficeFactsInput;
};

type TVariables = {
  id: number;
};

function useGetOfficeFactsInfo(id: number): UseQueryResult<TResult, TError> {
  return useQuery(
    ['get_officeFacts', id],
    async () => {
      const fetchResponse = await fetchOfficeFacts({ id });
      if (fetchResponse.Data !== null) {
        const result: OfficeFactsInput = {
          Account: fetchResponse.Data.Account,
          AccountId: fetchResponse.Data.AccountId,
          CallbackProcedures: fetchResponse.Data.CallbackProcedures,
          Coverage: fetchResponse.Data.Coverage,
          Hours: fetchResponse.Data.Hours,
          Id: fetchResponse.Data.Id,
          Notes: fetchResponse.Data.Notes,
        };
        return {
          officeFactsInputs: result,
          officeFactsReturn: fetchResponse.Data,
        };
      }
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetOfficeFactsInfo };
